import React, { useState } from 'react'
import styled from 'styled-components'
import Carousel from '@brainhubeu/react-carousel'
import '@brainhubeu/react-carousel/lib/style.css'
import Icon from '@mdi/react'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import Fade from 'react-reveal/Fade'
import Jed from './Images/Testimonials/Jed';
import Joanna from './Images/Testimonials/Joanna';
import Johan from './Images/Testimonials/Johan';
import Julie from './Images/Testimonials/Julie';
import Kira from './Images/Testimonials/Kira';
import Odina from './Images/Testimonials/Odina';
import Rachel from './Images/Testimonials/Rachel';
import Levi from './Images/Testimonials/Levi';

const Section = styled.div`
	padding: 8rem 0;
	margin: 0 auto;
	
	button {
	    background: none;
	}
	
	.BrainhubCarousel__dots .BrainhubCarousel__dot:before {
	    background: orange;
	}
`

const TitleWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 3rem;
`;

const Title = styled.h2`
    position: relative;
	text-align: center;
	font-size: 28px;
	color: #000;
	
	@media (min-width: 768px) {
	    font-size: 32px;
	}
	
	&:before {
	    content: '';
	    position: absolute;
	    background: #000;
	    height: 100px;
	    width: 1px;
	    bottom: calc(100% + 2rem);
	    left: 50%;
	}
`

const TestimonialCard = styled.div`
    position: relative;
	box-shadow: rgba(0, 0, 0, 0.25) 0px 15px 30px 0px;
    padding: 3rem 2rem 2rem;
    width: 300px;

	@media (min-width: 768px) {
		width: 600px;
		padding: 5rem 4rem 4rem;
	}
`

const Photo = styled.div`
    position: absolute;
    top: -45px;
    left: calc(50% - 45px);
    
    .gatsby-image-wrapper {
        height: 90px;
        width: 90px;
        border-radius: 90px;
    }
`

const Body = styled.div`
	margin-bottom: 2rem;
	
	p {
	    margin-bottom: 1rem;
	};
	
	@media (min-width: 768px) {
        font-size: 18px;
	}
`

const Name = styled.div`
    color: #000;
	text-align: center;
	text-transform: uppercase;
	letter-spacing: 1.4px;
	font-weight: bold;
`

const PersonTitle = styled.div`
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
	letter-spacing: 1.4px;
`

const CardWrapper = styled.div`
	padding: 3rem 0;
`;

const Button = styled.button`
	border: none;
	outline: none;
	width: 45px;
	height: 45px;
	cursor: pointer;
	background: transparent;
	margin: 1rem;
	
	svg {
	    color: orange;
	}
`;

const Testimonials = () => {
    const [slide, setSlide] = useState(0);

    return (
        <Section>
            <Fade duration={500} up cascade>
                <TitleWrapper>
                    <Button onClick={() => setSlide(slide - 1)}>
                        <Icon path={mdiChevronLeft} />
                    </Button>

                    <Title>
                        What People<br />Are Saying
                    </Title>

                    <Button onClick={() => setSlide(slide + 1)}>
                        <Icon path={mdiChevronRight} />
                    </Button>
                </TitleWrapper>
            </Fade>

            <Carousel
                keepDirectionWhenDragging
                value={slide}
                onChange={setSlide}
                // autoPlay={5000}
                infinite
                centered
                dots
                slidesPerPage={1}
                breakpoints={{
                    1425: {
                        slidesPerPage: 1,
                    },
                    1920: {
                        slidesPerPage: 2,
                        clickToChange: true
                    }
                }}>
                <CardWrapper>
                    <TestimonialCard>
                        <Photo><Kira /></Photo>
                        <Body>
                            <p>I’ve had lower back/ hip pain for the last 4 1/2 yrs and nothing has ever given me relief. I was introduced to Emanuel and I have had amazing experiences with every body code session. We first worked on my lower back and instantly I felt relief!! I went camping two days later and I knew that my back would give out because that’s what happens every time I go camping. Nope!! Not this time! I was pain free and not hunched over!!</p>
                            <p>So amazing!!!Then today we were working on my daughter and during the whole time we were talking my hip was super stiff and hurting. He did some of his healing, miracle stuff and instantly my hip is pain free!!! This guy is the real deal and knows how to connect with your spirit. I’m still learning all this stuff and I’m for sure a firm believer!!!! Thank you Emanuel!!!</p>
                        </Body>
                        <Name>Kira Shelby Stevens </Name>
                        <PersonTitle>Satisfied Client</PersonTitle>
                    </TestimonialCard>
                </CardWrapper>

                <CardWrapper>
                    <TestimonialCard>
                        <Photo><Rachel /></Photo>
                        <Body>We had the blessing of a session with Emanuel. My 77 year old father has been burdened with hip and groin pain for the past few months.  Around an 8 pain level in his hip and 3/4 in other before his session.    Within  20 minute of his cession my father was able to walk around with little to no pain whatsoever.   We are a few day out and happily he reports that those areas are still pain free!    What an amazing blessing!   You don’t have to be weighted down with pain.    Take the opportunity to be free.</Body>
                        <Name>Rachel Lewis Evans</Name>
                        <PersonTitle>Satisfied Client</PersonTitle>
                    </TestimonialCard>
                </CardWrapper>

                <CardWrapper>
                    <TestimonialCard>
                        <Photo><Jed /></Photo>
                        <Body>Right off the bat, I felt my body want to fight the process of healing. We get so stuck in our grief and our stories, when people want to helps us we shut down. Emanuel was amazing and he was very patient and purposeful with his process. After only a few minutes I could feel the grief and sadness of parts of myself sift away after Emanuel started his healing process. I felt amazing after my session! Energy was way up, I felt lighter I laughed! It was phenomenal! I would definitely recommend Compass healing to anyone who has been through anything and is willing to go through the change. But here's the thing...you have to be willing.</Body>
                        <Name>Jed Hammond</Name>
                        <PersonTitle>Satisfied Client</PersonTitle>
                    </TestimonialCard>
                </CardWrapper>

                <CardWrapper>
                    <TestimonialCard>
                        <Photo><Joanna /></Photo>
                        <Body>After trying chiropractic, oils, and every homeopathic remedy I could find, I booked an appt for my 14 month old for insomnia issues. Turns out it was night terrors. The appt was on Wednesday and by Saturday night my little guy slept through the night! And I get to sleep in my own bed again. 🤗🙏🏼 Emanuel also worked on some speech issues and my son has said 4 new words in 4 days. I’m so glad I decided to give this a try!</Body>
                        <Name>Joanna Mast</Name>
                        <PersonTitle>Satisfied Client</PersonTitle>
                    </TestimonialCard>
                </CardWrapper>

                <CardWrapper>
                    <TestimonialCard>
                        <Photo><Julie /></Photo>
                        <Body>
                            <p>Highly recommend! Grateful to be a part of the Healers Success Guide training with Emanuel. Each time I’m amazed at how much content Emanuel packs into the sessions I’ve done with him. I have more tools (and ones that have been tested and worked for him) than I have time!</p>
                            <p>There’s no excuses after this in building a successful Emotion Code business. So far I’ve had 7 of the 12 meetings and love the combination of training AND healing. When we uncover areas I feel stuck on or insecure about doing, the next session we literally remove those energetic blocks. After one of the healing sessions, I saw specific immediate results that afternoon - and that became a reference for 4 more clients getting started with sessions too! Thank you Emmanuel for all you do to empower others along the way!</p>
                        </Body>
                        <Name>Julie Anna</Name>
                        <PersonTitle>Satisfied Client</PersonTitle>
                    </TestimonialCard>
                </CardWrapper>

                <CardWrapper>
                    <TestimonialCard>
                        <Photo><Johan /></Photo>
                        <Body>
                            I just had a session with Emanuel. He is really friendly and he does a very good job and works quickly. He discovered several things working on my lower back pain which I had for years already. I rated the pain 8/10. He discovered some imbalances in the organs (kidneys) and one inherited trapped emotion that set itself in the lower back. He released it on a distance - he being in the USA and me being in The Netherlands - and after the session the pain is gone. 0 out of 10! He also found a curse that blocked me from being abundant. And a miasm that went back 7 generations. He released it all. Really amazing. I definitely want to continue with more sessions as we will be working on my heartwall which I probably have (around 93% of people have one) So yeah, I definitely can recommend Compass Healing / Emanuel!
                        </Body>
                        <Name>Johan Korthout</Name>
                        <PersonTitle>Satisfied Client</PersonTitle>
                    </TestimonialCard>
                </CardWrapper>

                <CardWrapper>
                    <TestimonialCard>
                        <Photo><Odina /></Photo>
                        <Body>
                            <p>I have been working with Emanuel for about 3 years now and all I can say is wow!!</p>
                            <p>Let’s first start off with the heart wall! I was amazed at the fact he picked up on the major event that happened to me a child and then as a grownup. He was able to release all of those emotions that I didn’t know I had kept inside.</p>
                            <p>Now we get to the fun stuff!! If you have had any pain that is just unexplainable and you need relief Emanuel is the person to see. Within minutes the pain in my foot was gone!!! When I was having troubles in my relationship he was able to help me with the hurt and disappointed that I was feeling.</p>
                            <p>I highly recommend if you are looking for emotional coding Emanuel is your guy!!!</p>
                        </Body>
                        <Name>Odina Ponce</Name>
                        <PersonTitle>Satisfied Client</PersonTitle>
                    </TestimonialCard>
                </CardWrapper>

                <CardWrapper>
                    <TestimonialCard>
                        <Photo><Levi /></Photo>
                        <Body>
                            I had the awesome opportunity to work with Emanuel Zevallos on my first emotion code session today and I'll admit I was a little skeptical and was just giving it a try out of curiosity because I believe in self-healing and a huge fan of self-improvement. I figured why not just give it a shot and I am amazed by the result. What Emanuel did in our first 45 minutes took the pain I've had in my knees and back almost completely away within the 45 minutes and I spent the rest of my day feeling better than I have in a long time, like a pile of bricks was lifted off my shoulders. I recommend this to anybody who is dealing with pain or stress or any kind of issue that is holding them back. Believe me, I more than anybody was skeptical of even trying this but I am far from regretting it now and I'm stoked for my next session. I can see the emotional code being a great life-changing tool for me and I encourage anyone trying to better themselves or just trying to create positivity in their lives to just give this one try and be mind blown by what even one session can do for you. This is something everybody can use in their life and I can promise you that you won't regret giving this a shot.
                        </Body>
                        <Name>Levi Kingston</Name>
                        <PersonTitle>Satisfied Client</PersonTitle>
                    </TestimonialCard>
                </CardWrapper>
            </Carousel>
        </Section>
    )
}

export default Testimonials
